module.exports = __webpack_public_path__ + "static/media/info.f09e211f.svg";